import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { SignInFlowType } from "./SignInFlowTypes";
import LoginOtpCard from "./LoginOtpCard";
import LoginEmailCard from "./EmailCard";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import { captureUtmsFromUrl } from "@/lib/utms";
import AppInstallDialog from "../AppInstallDialog";
import { PageType } from "../PageType";

enum SignInStep {
  EMAIL = 1,
  OTP = 2,
}

export default function SignIn({ flowType }: { flowType: SignInFlowType }) {
  const [step, setStep] = useState<SignInStep>(SignInStep.EMAIL);
  const [email, setEmail] = useState("");
  const [dynamicFlowType, setDynamicFlowType] = useState(flowType);
  const [previousStep, setPreviousStep] = useState<SignInStep | null>(null);
  const [visitorId, setVisitorId] = useState<string>("");

  useEffect(() => {
    const url = new URL(window.location.href);
    const referralCode = url.searchParams.get("code");
    if (referralCode) {
      localStorage.setItem("referralCode", referralCode);
    }

    try {
      captureUtmsFromUrl();
    } catch (error) {
      console.error("UTM capture failed", error);
    }

    const initFingerprint = async () => {
      try {
        const fp = await FingerprintJS.load();
        const result = await fp.get();
        setVisitorId(result.visitorId);
      } catch (error) {
        console.error("FingerprintJS failed", error);
      }
    };

    void initFingerprint();
  }, []);

  const onEmailSuccess = (email: string) => {
    setEmail(email.toLowerCase());
    setPreviousStep(SignInStep.EMAIL);
    setStep(SignInStep.OTP);
  };

  const handleGoBack = () => {
    setPreviousStep(SignInStep.OTP);
    setStep(SignInStep.EMAIL);
  };

  const emailInitialX = previousStep === SignInStep.OTP ? -50 : 50;

  return (
    <div className="flex w-full items-center justify-center">
      <AnimatePresence mode="wait">
        {step === SignInStep.EMAIL ? (
          <motion.div
            key="email"
            initial={{ opacity: 0, x: emailInitialX }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -50 }}
            transition={{ duration: 0.1 }}
          >
            <LoginEmailCard
              onSuccess={onEmailSuccess}
              flowType={dynamicFlowType}
              changeFlowType={setDynamicFlowType}
              fingerprint={visitorId}
            />
          </motion.div>
        ) : (
          <motion.div
            key="otp"
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -50 }}
            transition={{ duration: 0.1 }}
          >
            <LoginOtpCard
              email={email}
              onGoBack={handleGoBack}
              type={dynamicFlowType}
              fingerprint={visitorId}
            />
          </motion.div>
        )}
      </AnimatePresence>
      <AppInstallDialog pageType={PageType.SIGN_IN} />
    </div>
  );
}
